import { render } from "./AlterarSenha.vue?vue&type=template&id=a85f2844&scoped=true"
import script from "./AlterarSenha.vue?vue&type=script&lang=js"
export * from "./AlterarSenha.vue?vue&type=script&lang=js"

import "./AlterarSenha.vue?vue&type=style&index=0&id=a85f2844&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85f2844"]])

export default __exports__